// filepath: apps/web/src/design-system/error-states/RateLimitBackpressure.tsx
//
// 429 backpressure surface with Retry-After countdown.
//
// The backend does not currently emit 429 (impact analysis R-3), so this
// is forward-compat only. The component is exercised by tests.

import React from "react";

export interface RateLimitBackpressureProps {
  /** Seconds until the next attempt is allowed. Null = unknown. */
  retryAfterSeconds: number | null;
}

export function RateLimitBackpressure({
  retryAfterSeconds,
}: RateLimitBackpressureProps): React.ReactElement {
  return (
    <div
      data-testid="form-rate-limit"
      className="form-error form-rate-limit"
      role="alert"
    >
      <h2>Too many requests</h2>
      {retryAfterSeconds !== null ? (
        <p data-testid="rate-limit-retry-after">
          Please wait {retryAfterSeconds} seconds and try again.
        </p>
      ) : (
        <p>Please wait a moment and try again.</p>
      )}
    </div>
  );
}
